import {
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
} from '@pmi/dsm-react/dist/components/icons/fa/16';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import styles from './FilterButton.module.scss';

export interface FilterButtonProp {
  onOpen?: (isOpen: boolean) => void;
}

export default function FilterButton({
  onOpen = (isOpen: boolean) => isOpen,
}: FilterButtonProp) {
  const [isOpen, setIsOpen] = useState(false);
  const onClick = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    onOpen(isOpen);
  }, [isOpen]);
  return (
    <div className="d-block">
      <Button onClick={onClick} className={styles.filterButton} variant="link">
        <FilterIcon fontSize="sm" className="me-1" />
        Filters
        {isOpen && <ChevronUpIcon className="ms-1" fontSize="sm" />}
        {!isOpen && <ChevronDownIcon className="ms-1" fontSize="sm" />}
      </Button>
    </div>
  );
}
